var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"bg-white w-100 h-100",attrs:{"fluid":""}},[_c('b-row',{staticClass:"custom-row"},[_c('figure',{staticClass:"text-center w-100 mt-4"},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}})]),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }